var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.accepted
    ? _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show",
            },
          ],
          staticClass: "gdpr-notification",
          class: _vm.show ? "visible" : "",
        },
        [
          _c(
            "silhouette-assistant",
            { attrs: { "image-name": `${_vm.character}.svg`, "bubble-nr": 0 } },
            [
              _c(
                "div",
                {
                  staticClass: "banner",
                  attrs: {
                    role: "alertdialog",
                    "aria-labelledby": "gdpr-banner-title",
                  },
                },
                [
                  _c("p", {
                    attrs: { id: "gdpr-banner-title" },
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("user.gdprCookieNotice")),
                    },
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      attrs: { role: "button", "aria-pressed": "false" },
                      on: { click: _vm.accept },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.ok")))]
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }